export const navLinks = {
  employer: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "faGrip",
    },
    {
      name: "Employees",
      url: "/employees",
      icon: "faUsers",
    },
    {
      name: "Payroll",
      url: "/payroll",
      icon: "faFileInvoiceDollar",
    },
    {
      name: "Wallet",
      url: "/wallet",
      icon: "faWallet",
    },
    {
      name: "Departments",
      url: "/departments",
      icon: "faBuilding",
    },
    {
      name: "Report Summary",
      url: "/reportsummary",
      icon: "faChartBar",
      subItems: [
        {
          name: "Summary",
          url: "/reportsummary/summary",
        },
        {
          name: "Variance",
          url: "/reportsummary/variance",
        },
        {
          name: "General",
          url: "/reportsummary/general",
        },
        {
          name: "PAYE",
          url: "/reportsummary/paye",
        },
        {
          name: "Pension",
          url: "/reportsummary/pension",
        },
        {
          name: "Payroll Report",
          url: "/reportsummary/payroll",
        },
      ],
    },
    {
      name: "Payroll Setup",
      url: "/payrollsettings",
      icon: "faGears",
    },
  ],
  employee: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "faGrip",
    },
    {
      name: "My Profile",
      url: "/employee/profile",
      icon: "faUser",
    },
    {
      name: "Password Reset",
      url: "/resetpassword",
      icon: "faLock",
    },
  ],
  admin: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "faGrip",
    },
    {
      name: "Companies",
      url: "/admin/companies",
      icon: "faBuilding",
    },
    {
      name: "Referral",
      url: "/admin/referral",
      icon: "faHandshake",
    },
    {
      name: "Plans & Pricing",
      url: "/admin/pricing",
      icon: "faTag",
    },
    {
      name: "Billing",
      url: "/admin/billing",
      icon: "faCreditCard",
    },
  ],
};

export const navAvatarAreaLinks = {
  employer: [
    {
      name: "Profile",
      url: "/employer/profile",
    },
    {
      name: "Add new company",
      url: "/setup",
    },
    {
      name: "Password Reset",
      url: "/passwordreset",
    },
    {
      name: "Logout",
      url: "/",
    },
  ],
  employee: [
    {
      name: "Logout",
      url: "/",
    },
  ],
  admin: [
    {
      name: "Password Reset",
      url: "/passwordreset",
    },
    {
      name: "Logout",
      url: "/",
    },
  ],
};
